import React from "react";
import { PropTypes } from "prop-types";
import { FormField, TextInput } from "@kui/foundations-react";

const Input = (props) => {
  // errorText with no explicit status shows the field in the error state
  const status = props.errorText && !props.status ? "error" : props.status;
  // regField adds no box of its own (display: contents); data-field-error lets the form
  // scroll to the first invalid field
  return (
    <div className="regField" data-field-error={props.errorText ? "true" : undefined}>
    <FormField
      id={props.id}
      slotLabel={props.labelText}
      slotInfo={props.datatip}
      slotHelp={props.helpText}
      slotError={props.errorText}
      slotSuccess={props.successText}
      status={status}
      required={props.isRequired}
      labelPosition="top"
    >
      <TextInput
        size="medium"
        type={props.type}
        placeholder={props.placeholder}
        defaultValue={props.defaultValue}
        value={props.value}
        onChange={props.onChange}
        onBlur={props.onBlur}
        onPaste={props.onPaste}
        disabled={props.readOnly}
        maxLength={props.maximumLength}
      />
    </FormField>
    </div>
  );
};

Input.propTypes = {
  isRequired: PropTypes.bool,

  labelText: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  datatip: PropTypes.string,
  helpText: PropTypes.node,
  errorText: PropTypes.node,
  successText: PropTypes.node,
  status: PropTypes.oneOf(["success", "error"]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onPaste: PropTypes.func,
  readOnly: PropTypes.bool,
  id: PropTypes.string,
  maximumLength: PropTypes.number,
};

Input.defaultProps = {
  type: "text",
  readOnly: false,
  isRequired: false,
};

export default Input;
